import React from "react";
import Icon from "../Icon";

export default (props) => (
  <Icon viewBox="0 0 32 32" {...props}>
    <path d="M2 21h28M2 11h28" fill="none" />
  </Icon>
);
